function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M0,11.83A102.22,102.22,0,0,1,31.56,1.17,102.91,102.91,0,0,1,55,.29,3.6,3.6,0,0,1,56.74,1a3.13,3.13,0,0,0-.76.28C47.64,7,43.53,14.89,43.28,25A20.87,20.87,0,0,1,26.36,45.41c-9.29,1.91-19.6-2.93-23-11.75C1.54,28.77,1.33,23.25.39,18,.24,17.2.13,16.39,0,15.58Zm93.76,3.33c-.55,4-1,8-1.66,11.91a97.46,97.46,0,0,1-16,38.47,9.52,9.52,0,0,1-.68.83,81.48,81.48,0,0,0-2.26-9A27.54,27.54,0,0,0,61,43.05,20.86,20.86,0,0,1,50.85,20.72,20.69,20.69,0,0,1,68,4.13a17.66,17.66,0,0,1,8.37.5C82.25,6.69,88,9.39,93.76,11.83Zm-85,34.37c7.14,3.58,14.21,4.51,21.52,2.26a35.49,35.49,0,0,0,6.27-2.72A21,21,0,0,1,65.33,77.39a13.8,13.8,0,0,1-3.17,4c-4.22,3.48-8.6,6.77-12.93,10.12a3.64,3.64,0,0,1-4.61.08A98.32,98.32,0,0,1,9,50.48C9,50.31,8.91,50.11,8.72,49.53Z"
})));

var SvgXem = function SvgXem(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 93.76 92.42",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgXem, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/xem.3d327168.svg";
export { ForwardRef as ReactComponent };